import React, { useState, useEffect } from "react";
import Card from "./Card";
import { fetchGifs } from "../api";

const CardGrid = ({ updateScore }) => {
  const [cards, setCards] = useState([]);
  const [clickedCards, setClickedCards] = useState([]);

  useEffect(() => {
    const loadCards = async () => {
      const fetchedCards = await fetchGifs();
      setCards(fetchedCards);
    };
    loadCards();
  }, []);

  const shuffleCards = () => {
    setCards((prev) => [...prev].sort(() => Math.random() - 0.5));
  };

  const handleCardClick = (id) => {
    if (clickedCards.includes(id)) {
      setClickedCards([]);
      updateScore(0);
    } else {
      setClickedCards([...clickedCards, id]);
      updateScore((prev) => prev + 1);
    }
    shuffleCards();
  };

  return (
    <div className="card-grid">
      {cards.map((card) => (
        <Card key={card.id} image={card.image} onClick={() => handleCardClick(card.id)} />
      ))}
    </div>
  );
};

export default CardGrid;
